<template>
  <div><div class="thank-you-container" v-html="message"></div></div>

</template>
<script setup lang="ts">
defineProps<{
  message?: string
}>()
</script>
<style scoped>
.thank-you-container {
  padding: 50px;
  text-align: center;
  min-height: 300px;
  color: black;
  font-weight: bold;
}
</style>
